import { effect, Injectable, signal } from '@angular/core';

export const VALUE_DISPLAY_FILTER_KEY = 'Relativ oder Absolut';

const STORAGE_KEY = 'wct.value-display';

function read(): string | null {
  try {
    return localStorage.getItem(STORAGE_KEY);
  } catch {
    return null;
  }
}

function write(value: string | null): void {
  try {
    if (value === null) {
      localStorage.removeItem(STORAGE_KEY);
    } else {
      localStorage.setItem(STORAGE_KEY, value);
    }
  } catch {
    // storage unavailable (private mode, quota) - selection just won't persist
  }
}

/** Global relative/absolute selection; the available values are provided by the backend filter. */
@Injectable({ providedIn: 'root' })
export class ValueDisplayService {
  readonly value = signal<string | null>(read());

  constructor() {
    effect(() => write(this.value()));
  }

  set(value: string): void {
    this.value.set(value);
  }
}
